import { can, CAPABILITY } from '@aytm/app/stats/page/data-quality-report/lib/tiers'

// A children list of length > 1 renders as a real expandable group (chevron + indented child
// rows); length <= 1 collapses to a flat leaf row. Below the subvector tier (Lite) every group
// collapses to its primary vector, so the tier is part of the shape, not just of the chevron.
//
// Single definition on purpose: the section, the vector row and the total each used to derive
// this independently, and they disagreed — the row was tier-gated while the total was not, which
// left a below-tier multi-leaf parent both flattened AND stripped of its status popup.
export const isExpandableGroup = (vector, tier) =>
  can(tier, CAPABILITY.SHOW_SUBVECTORS) && 1 < (vector.group?.length ?? 0)

// The `checked` value a plain toggle of this row will dispatch. An expandable parent toggles on
// "is any child still off", not on its own flag, so a partially-checked parent turns everything
// ON. The Shift-range anchor must record this same value — recording `!vector.checked` instead
// made the two disagree, and the anchor was then silently discarded.
export const targetChecked = (vector, item, tier) => {
  if (item) return !item.checked

  return isExpandableGroup(vector, tier)
    ? vector.group.some(_item => !_item.checked && !_item.disabled)
    : !vector.checked
}
